import { useState } from "react";
import CompanyDataListItem from "./CompanyDataListItem";
import { useCachedFirebaseCrud } from "../../../helpers/firebase";
import { TextField } from "@aclymatepackages/atoms";

const CompanyNameRow = ({ name: companyName, displayName }) => {
  const name = displayName || companyName;
  const { updateAccountData } = useCachedFirebaseCrud();

  const [modifyName, setModifyName] = useState(name);
  const [isModified, setIsModified] = useState(false);
  const nameIsTooLong = modifyName?.length > 40;

  return (
    <CompanyDataListItem
      editingComponent={
        <TextField
          value={modifyName}
          setValue={(newValue) => {
            setModifyName(newValue);
            setIsModified(true);
          }}
          variant="standard"
          label="Edit Company Name"
          InputProps={{ style: { width: "250px" } }}
          helperText={
            nameIsTooLong &&
            "Your company's name should be less than 40 characters long"
          }
          error={nameIsTooLong}
        />
      }
      saveDisabled={!modifyName || nameIsTooLong}
      onCancel={() => {
        setIsModified(false);
        setModifyName(name);
      }}
      onSave={() => {
        setIsModified(false);
        updateAccountData({ displayName: modifyName });
      }}
      primaryText={name}
      secondaryText="Company Name"
      isTextField={true}
      isUpdated={isModified}
    />
  );
};

export default CompanyNameRow;
